import Rails from '@rails/ujs'
import _ from "lodash";

export default class SmallActivities {
  constructor(base_url) {
    this.base_url = base_url
  }

  call() {
    this.getData()
  }

  getData() {
    let url = this.base_url + '/show_data?data_type=small_event_actions'

    Rails.ajax({
      type: "GET",
      url: url,
      success: this.successResponse.bind(this)
    })
  }

  successResponse(response) {
    this.data = response
    this.wrapperSmallActivities.innerHTML = this.parseTemplate()
  }

  parseTemplate () {
    _.templateSettings = {
      evaluate:    /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape:      /\{\{-(.+?)\}\}/g
    }

    let compiled = _.template(this.templateSmallActivities.innerHTML)

    return compiled(this.data)
  }

  get wrapperSmallActivities() {
    return document.getElementById('wrapper-small-activities')
  }

  get templateSmallActivities() {
    return document.getElementById('template-small-activities')
  }
}